import { Routes } from '@angular/router';
import { Login } from './Components/login/login';
import { BankDetail } from './Components/bank-detail/bank-detail';
import { ProductList } from './Components/product-list/product-list';
import { OrderCommission } from './Components/order-commission/order-commission';
import { authGuard } from './Common/auth.guard';
import { Singup } from './Components/singup/singup';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },

    { path: 'login', component: Login, data: { title: 'Login' } },
    {
        path:'signup',
        component: Singup,
        data: { title: 'Signup' }
    },

    {
        path: 'bank-detail',
        component: BankDetail,
        canActivate: [authGuard],
        data: { title: 'Bank Detail' }
    },
    {
        path: 'product-list',
        component: ProductList,
        canActivate: [authGuard],
        data: { title: 'Product List' }
    },
    {
        path: 'order-commission',
        component: OrderCommission,
        canActivate: [authGuard],
        data: { title: 'Order Commission' }
    },

    { path: '**', redirectTo: 'login' }
];